import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ArrowRight, Check, Leaf, ShieldCheck, Tractor } from "lucide-react";
import { api } from "../api";
import { Brand } from "../components/Brand";
import { useAuth } from "../auth";
import { navigate } from "../router";

export function LoginPage() {
  const profiles = useQuery({ queryKey: ["profiles"], queryFn: api.profiles });
  const auth = useAuth();
  const queryClient = useQueryClient();
  const login = async (id: string) => {
    await api.login(id); await auth.refresh(); await queryClient.invalidateQueries();
    navigate("/dashboard");
  };
  return <div className="login-layout">
    <section className="login-story">
      <Brand />
      <div className="story-copy"><span className="eyebrow"><Leaf size={15} /> Pensé pour le terrain</span><h1>L’exploitation, enfin<br />dans le bon sens.</h1><p>Centralisez vos parcelles, interventions, stocks et documents dans un espace aussi clair que votre journée doit l’être.</p>
        <ul><li><Check />Une vue fiable sur toute l’activité</li><li><Check />Une traçabilité pensée dès le départ</li><li><Check />Vos données isolées et protégées</li></ul>
      </div>
      <div className="story-visual"><div className="field-line line-one" /><div className="field-line line-two" /><Tractor size={38} /></div>
    </section>
    <section className="login-panel"><div className="login-card">
      <span className="dev-badge"><ShieldCheck size={14} /> Environnement de développement</span>
      <h2>Bienvenue sur AgriFlow</h2><p>Choisissez un profil local pour ouvrir votre espace de travail.</p>
      <div className="profile-list">
        {profiles.isLoading && <div className="skeleton tall" />}
        {profiles.isError && <div className="alert error">Les profils ne sont pas disponibles. Vérifiez que l’API et le seed sont lancés.</div>}
        {profiles.data?.data.map((profile) => <button key={profile.id} onClick={() => void login(profile.id)}><span className="avatar large">{profile.displayName.split(" ").map((p) => p[0]).join("").slice(0, 2)}</span><span><strong>{profile.displayName}</strong><small>{profile.email}</small></span><ArrowRight size={18} /></button>)}
      </div>
      <small className="login-note">Ce mécanisme est automatiquement désactivé en production.</small>
    </div></section>
  </div>;
}
